module.exports = __webpack_public_path__ + "img/levähdyspaikka_original.716d629d.jpg";